import { Identifier } from "../models";
import { ICheckbox } from "../ui/interfaces/Checkbox";

export class CheckboxFactory {
  public create = (waardelijstItem: Identifier, checked: boolean, bold?: boolean, disabled?: boolean): ICheckbox => ({
    id: waardelijstItem.id,
    label: waardelijstItem.label ?? waardelijstItem.id,
    checked: checked,
    bold: bold,
    disabled: disabled,
  });
}
